/*
 * <autoship-toggle> — AutoShip/One-Time deselect handler for main-product-v2.
 *
 * The basic AutoShip vs One-Time switch is handled by the shared <selling-plans> /
 * <purchase-option> components (global.js). This element ports the deselect UX from
 * <aiw-autoship-toggle> (assets/aiw-v2-autoship-toggle.js) to the v2 buy box without
 * touching the AIW file: click a checked AutoShip card (or its "No thanks"
 * [data-purchase-option-deselect] button) to snap back to One-Time. Scoped to .main-product-v2.
 */
if (customElements.get('autoship-toggle') === undefined) {
  class AutoshipToggle extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      // Scope strictly to this product section. Don't fall back to document —
      // a document-wide listener could deselect the wrong product's AutoShip on
      // a multi-section page, and the failure would be invisible.
      this.scope = this.closest('.main-product-v2');
      if (!this.scope) {
        if (typeof console !== 'undefined') {
          console.warn('[autoship-toggle] no .main-product-v2 scope — toggle inert');
        }
        return;
      }
      this.scope.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.scope) this.scope.removeEventListener('click', this.onClick);
    }

    selectOneTime() {
      const oneTimeRadio = this.scope.querySelector('.purchase-option--one-time .purchase-option__radio');
      if (!oneTimeRadio) {
        if (typeof console !== 'undefined') console.warn('[autoship-toggle] one-time radio missing — deselect inert');
        return;
      }
      oneTimeRadio.checked = true;
      oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onClick(e) {
      // "No thanks" button inside the open AutoShip card
      if (e.target.closest('[data-purchase-option-deselect]')) {
        e.preventDefault();
        this.selectOneTime();
        return;
      }

      // ::before overlay on a checked AutoShip card. Pseudo-elements aren't event
      // targets, so the click fires on the .purchase-option__inner element itself.
      if (e.target.classList && e.target.classList.contains('purchase-option__inner')) {
        const po = e.target.closest('.purchase-option');
        if (!po) return;
        const isChecked = po.classList.contains('purchase-option--checked');
        const isOneTime = po.classList.contains('purchase-option--one-time');
        if (isChecked && !isOneTime) {
          e.preventDefault();
          this.selectOneTime();
        }
      }
    }
  }

  customElements.define('autoship-toggle', AutoshipToggle);
}
